export function trailingSlashCheck(input: string) {
    const hasDomain = input.startsWith('https');
    const hasLeadingSlash = input.startsWith('/');
    const zooplaDomain = 'https://www.zoopla.co.uk';

    const urlObj = hasDomain ? new URL(input) : new URL(input, zooplaDomain);

    if (urlObj.hash && urlObj.pathname === null) {
        return input;
    }

    if (!urlObj?.pathname?.endsWith('/')) {
        urlObj.pathname = `${urlObj.pathname}/`;
    }

    const newLink = urlObj.toString();

    if (hasDomain) {
        return newLink;
    }

    if (hasLeadingSlash) {
        return newLink.replace(zooplaDomain, '');
    }

    return newLink.replace(`${zooplaDomain}/`, '');
}
